import type React from 'react'
import { useState } from 'react'
import ImageIcon from '../icons/ImageIcon'
import { cn } from '../lib/cva'

interface ClientLogoProps {
	url: string | null | undefined
	className?: string
}

export const ClientLogo: React.FC<ClientLogoProps> = ({ url, className }) => {
	const [errorUrl, setErrorUrl] = useState<string | null>(null)
	const hasError = url != null && errorUrl === url
	const showPlaceholder = hasError || !url

	return (
		<div className='flex'>
			<div
				className={cn(
					'flex h-15 w-15 items-center justify-center p-0.5 rounded-sm border border-neutral-200 bg-neutral-0',
					className,
				)}>
				{showPlaceholder ? (
					<div className='h-full w-full flex items-center justify-center bg-neutral-100 rounded-sm'>
						<ImageIcon size={32} className='fill-neutral-400' />
					</div>
				) : (
					// Reserve the full container so a broken or zero-dimension response can't
					// collapse the box to 0px wide. onLoad guards against responses that "load"
					// successfully but have no actual image content (HTTP 200 with empty body),
					// since onError doesn't fire for that case.
					<img
						className='h-full w-full object-contain'
						src={url}
						alt='Organization logo'
						onError={() => setErrorUrl(url)}
						onLoad={(e) => {
							const img = e.currentTarget
							if (img.naturalWidth === 0 || img.naturalHeight === 0) {
								setErrorUrl(url)
							}
						}}
					/>
				)}
			</div>
		</div>
	)
}
